/** Single source of truth — aligned with merchant + customer Flutter apps */
export const brand = {
  primary: '#0B2545',
  secondary: '#134074',
  accent: '#00A86B',
  alert: '#D90429',
  background: '#F8F9FA',
  ink: '#1E2229',
  border: '#E2E5E9',
  primarySoft: '#E8EEF5',
  accentSoft: '#E6F7F0',
  white: '#FFFFFF',
  muted: '#6B7280',
  mutedSoft: '#9CA3AF',
  siderDark: '#081A30',
  onPrimary: '#FFFFFF',
  shadowSoft: 'rgba(11, 37, 69, 0.04)',
  shadowCard: 'rgba(11, 37, 69, 0.18)',
  onPrimaryMuted: 'rgba(255, 255, 255, 0.88)',
  onPrimarySubtle: 'rgba(255, 255, 255, 0.08)',
  warning: '#E9985D',
};

/** Ant Design theme schema — components should prefer theme.useToken() */
export const antdTheme = {
  token: {
    colorPrimary: brand.accent,
    colorInfo: brand.secondary,
    colorSuccess: brand.accent,
    colorError: brand.alert,
    colorWarning: brand.warning,
    colorText: brand.ink,
    colorTextSecondary: brand.muted,
    colorTextTertiary: brand.mutedSoft,
    colorTextLightSolid: brand.onPrimary,
    colorBorder: brand.border,
    colorBorderSecondary: brand.border,
    colorBgLayout: brand.background,
    colorBgContainer: brand.white,
    colorBgElevated: brand.white,
    colorFillAlter: brand.primarySoft,
    colorLink: brand.secondary,
    colorBgMask: 'rgba(11, 37, 69, 0.45)',
    borderRadius: 10,
    borderRadiusLG: 12,
    fontFamily:
      "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    // Custom aliases available via token (antd merges unknown token keys)
    colorBrandPrimary: brand.primary,
    colorBrandSecondary: brand.secondary,
    colorBrandAccent: brand.accent,
    colorBrandSoft: brand.primarySoft,
    colorAccentSoft: brand.accentSoft,
  },
  components: {
    Layout: {
      siderBg: brand.primary,
      triggerBg: brand.secondary,
      headerBg: brand.white,
      bodyBg: brand.background,
      lightSiderBg: brand.primary,
    },
    Menu: {
      darkItemBg: brand.primary,
      darkSubMenuItemBg: brand.siderDark,
      darkItemSelectedBg: brand.secondary,
      darkItemHoverBg: brand.secondary,
      darkItemColor: brand.onPrimaryMuted,
      darkItemSelectedColor: brand.onPrimary,
    },
    Button: {
      primaryColor: brand.onPrimary,
      colorPrimary: brand.accent,
      algorithm: true,
    },
    Card: {
      colorBgContainer: brand.white,
    },
    Table: {
      headerBg: brand.primarySoft,
      borderColor: brand.border,
    },
  },
};

/** Apply CSS custom properties for stylesheets (login.css, etc.) */
export function applyBrandCssVariables(target = document.documentElement) {
  if (!target?.style) return;
  const map = {
    '--color-primary': brand.primary,
    '--color-secondary': brand.secondary,
    '--color-accent': brand.accent,
    '--color-alert': brand.alert,
    '--color-background': brand.background,
    '--color-ink': brand.ink,
    '--color-border': brand.border,
    '--color-primary-soft': brand.primarySoft,
    '--color-accent-soft': brand.accentSoft,
    '--color-white': brand.white,
    '--color-muted': brand.muted,
    '--color-muted-soft': brand.mutedSoft,
    '--color-sider-dark': brand.siderDark,
    '--color-on-primary': brand.onPrimary,
    '--color-on-primary-muted': brand.onPrimaryMuted,
    '--color-on-primary-subtle': brand.onPrimarySubtle,
    '--color-warning': brand.warning,
    '--shadow-soft': brand.shadowSoft,
    '--shadow-card': brand.shadowCard,
  };
  Object.entries(map).forEach(([key, value]) => {
    target.style.setProperty(key, value);
  });
}
